<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div slot="header">
        <i class="fa fa-list mr-2"></i><strong>Gestion Domaines/Equipes</strong>
        <div class="card-header-actions">
          <b-link class="card-header-action btn-minimize" v-b-toggle.collapse2>
            <span class="when-opened"><i class="icon-arrow-down"></i></span>
            <span class="when-closed"><i class="icon-arrow-up"></i></span>
          </b-link>
        </div>
      </div>
      <b-collapse id="collapse2" visible>
        <b-card-body>
          <v-client-table :columns="columns" :data="data" :options="options">
            <div v-if="props.row.created_at" slot="created_at" slot-scope="props" class="slot-date">
              <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
            </div>
            <div v-if="props.row.equipes" slot="equipes" slot-scope="props" class="">
              <b-badge class="mr-1" v-for="equipe in props.row.equipes" variant="warning" :key="equipe.id">{{ equipe.libelle }}</b-badge>
            </div>

            <div slot="action" slot-scope="props">
              <i class="fa fa-pencil mr-2 text-primary clickable" @click="showEdit(props.row)"></i>
              <i class="fa fa-trash clickable text-danger" @click.prevent="destroy(props.row.id)"></i>
            </div>
          </v-client-table>
          <div slot="footer" class="mb-5">
            <b-button type="button" class="pull-right" size="md" variant="primary" v-b-modal.modal-domaine>
              <i class="fa fa-plus"></i> Ajouter un domaine
            </b-button>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-modal centered ref="domainemodal" id="modal-domaine">
      <template v-slot:modal-header>
        <h4> {{ modalTitle }} </h4>
      </template>
      <b-form-group
        label="Libellé"
        label-for="libelle"
        :label-cols="3"
        :horizontal="true">
        <b-form-input id="libelle" type="text" :class="{hasError: errors.libelle !== ''}"
                      v-model="libelle"></b-form-input>
        <span class="field-error">{{ errors.libelle }}</span>
      </b-form-group>
      <b-form-group
        label='Libellé complet'
        label-for='libelle-complet'
        :label-cols="3"
        :horizontal="true">
        <b-form-input id="libelle" type="text" :class="{hasError: errors.libelle_complet !== ''}"
                      v-model="libelle_complet"></b-form-input>
      </b-form-group>
      <b-form-group
        label="Ordre"
        label-for="ordre"
        :label-cols="3"
        :horizontal="true">
        <b-form-input id="ordre" type="number" min="0" v-model="ordre"></b-form-input>
      </b-form-group>
      <b-form-group>
        <label for="equipeSelect"><strong>Equipes</strong></label>
        <multiselect v-model="selectedEquipes"
          selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné'
          deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="false"
          tag-placeholder="Choisissez une ou plusieurs équipe(s)" placeholder="Choisissez une ou plusieurs équipe(s)"
          label="name" track-by="id"
          :options="equipeOptions" :multiple="true"
          :taggable="true">
        </multiselect>
      </b-form-group>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModal()">Annuler</button>
          <button type="button" @click="saveDomaine()" class="btn btn-primary">Valider</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { isEmpty } from "@/utils/fileHelper"
  import { espaceRCRules, hasRule } from "@/utils/rulesHelper"
  import Multiselect from 'vue-multiselect'

  export default {
    name: "Domaines",
    components: {
      Multiselect
    },
    data() {
      return {
        columns: ['created_at', 'libelle', 'libelle_complet', 'equipes', 'action'],
        data: [],
        options: {
          headings: {
            'created_at': 'Date de création',
            'libelle': 'Libellé',
            'libelle_complet': 'Libellé complet',
            'equipes': 'Equipes'
          },
          columnsClasses: {
            libelle: 'pre-formatted sort-top position-r col-xs',
            libelle_complet: 'pre-formatted sort-top position-r libelle-blocage-col-xs',
            equipes: 'pre-formatted sort-top position-r libelle-blocage-col-xs',
            created_at : 'pre-formatted sort-top position-r col-xs',
            action: 'pre-formatted sort-top position-r action-xs',
          },
          sortable: ['created_at', 'libelle'],
          filterable: ['libelle'],
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {
            filterPlaceholder: "Libelle"
          },
          orderBy: {column: 'libelle', ascending: false},
        },
        modalTitle: 'Ajouter un domaine',
        libelle: '',
        libelle_complet: '',
        ordre: 0,
        selectedDomaine: '',
        equipeOptions: [],
        selectedEquipes: [],
        isEmpty,
        errors: {
          libelle: '',
          libelle_complet: '',
          ordre: ''
        }
      }
    },
    mounted() {
      this.all()
    },
    created() {

    },
    methods: {
      all() {
        this.$store.commit("IS_LOADING", true)
        this.$axios
          .get("/espaceRelationClient/fiches/domaines")
          .then(response => {
            this.data = response.data.domaines
            for (let equipe of response.data.equipes) {
              this.equipeOptions.push({id: equipe.id, name: equipe.libelle});
            }
            this.$store.commit("IS_LOADING", false)
          })
          .catch(() => {
            this.$store.commit("IS_LOADING", false)
            this.handleError()
          });
      },
      saveDomaine() {
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true)
          let self = this
          let dataPost = {}
          dataPost.libelle = this.libelle
          dataPost.libelle_complet = this.libelle_complet
          dataPost.equipes = this.selectedEquipes.length > 0 ? this.selectedEquipes.map(equipe => equipe.id) : []
          dataPost.ordre = this.ordre
          dataPost.domaineId = this.selectedDomaine ? this.selectedDomaine : null
          let saveType = isEmpty(this.selectedDomaine) ? 'Création avec succès' : 'Modification avec succès'
          let successText = isEmpty(this.selectedDomaine) ? 'a bien été créé' : 'a bien été modifiée'
          this.$axios.post('/espaceRelationClient/fiches/domaine/store', dataPost)
            .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title: saveType, text: 'Le domaine ' + dataPost.libelle + successText, showConfirmButton: false, timer: 5000 })
              this.all()
              this.closeModal()
            })
            .catch(function (error) {
              self.$store.commit('IS_LOADING', false)
              self.$swal({ position: 'top', type: 'error', title: 'Attention !!', text: 'Un problème est survenu, merci de contacter l\'administration', showConfirmButton: false, timer: 5000 })
            })
        }
      },
      showEdit(domaine) {
        this.selectedDomaine = domaine.id
        this.modalTitle = "Modifier un domaine"
        this.libelle = domaine.libelle
        this.libelle_complet = domaine.libelle_complet
        this.ordre = domaine.ordre
        if (!isEmpty(domaine.equipes)) {
            this.selectedEquipes = []
            for (let equipe of domaine.equipes) {
                this.selectedEquipes.push({id: equipe.id, name: equipe.libelle})
            }
          } else {
            this.selectedEquipes = []
          }
        this.$refs.domainemodal.show()
      },
      destroy(id) {
        let self = this
        this.$swal
          .fire({
            title: "Êtes-vous sûr?",
            text: "Voulez-vous vraiment supprimer ce domaine ?",
            type: "warning",
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: "Annuler",
            cancelButtonText: "Supprimer"
          })
          .then(result => {
            if (!result.value) {
              this.$store.commit("IS_LOADING", true);
              this.$axios
                .post("/espaceRelationClient/fiches/domaine/delete/" + id)
                .then(response => {
                  this.$store.commit("IS_LOADING", false);
                  this.$swal({
                    position: "top",
                    type: "success",
                    title: "Suppression avec succès",
                    text: "Le domaine a bien été supprimé",
                    showConfirmButton: false,
                    timer: 5000
                  });
                  this.all();
                })
                .catch(function(error) {
                  this.$store.commit("IS_LOADING", false);
                  if (error.response.status == 401) {
                    this.$swal({
                      position: 'top',
                      type: 'warning',
                      title: 'Attention !!',
                      text: "La suppression est impossible, il existe encore des fiches associées à ce domaine.",
                      showConfirmButton: false,
                      timer: 5000
                    });
                  } else {
                    this.handleError();
                  }
                });
            }
          });
      },
      closeModal() {
        this.selectedDomaine = null
        this.$refs.domainemodal.hide()
        this.modalTitle = "Ajouter un domaine"
        this.libelle = ''
        this.libelle_complet = ''
        this.selectedEquipes = ''
        this.ordre = ''
      },
      validateData() {
        this.clearErrors()
        let valid = true
        if (this.libelle === "") {
          this.errors.libelle = "Le libellé est obligatoire"
          valid = false
        }
        if (this.libelle_complet === "") {
          this.errors.libelle_complet = "Le libellé complet est obligatoire"
          valid = false
        }

        return valid
      },
      clearErrors() {
        this.errors.libelle = ''
        this.errors.libelle_complet = ''
        this.errors.ordre = ''
      },
      handleError() {
        this.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
          showConfirmButton: false,
          timer: 5000
        });
      },
      formatDateHeure(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleString("fr-FR") : "-";
        return date
      },
      formatDate(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
        return date;
      }
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
